import { useLayoutEffect, useEffect } from 'react';
import { isBrowser } from '../helpers';

export const useIsomorphicLayoutEffect = isBrowser()
  ? useLayoutEffect
  : useEffect;
